// Tabs.tsx
import React from 'react';
import Images from '../common/Images';

export interface TabItem<T extends string | number> {
  id: T;
  label: string;
  icon?: React.ReactNode;
  img?: string;
}

interface TabsProps<T extends string | number> {
  tabs: TabItem<T>[];
  activeTab: T;
  onTabChange: (id: T) => void;
  showIcons?: boolean;
  className?: string;
  ActivetabClassName?: string;
  InActivetabClassName?: string;
  variant?: 'pill' | 'underline';
}

export const Tabs = <T extends string | number>({
  tabs,
  activeTab,
  onTabChange,
  showIcons = false,
  // ── Updated default: dark rounded container, full width ──
  className = 'bg-[#1a1a1a] rounded-xl p-1 w-full',
  ActivetabClassName = '',
  InActivetabClassName = '',
  variant = 'pill',
}: TabsProps<T>) => {
  return (
    <div className="overflow-x-auto scrollbar-hide w-full">
      <div
        className={`
    ${className} relative
    overflow-hidden flex
    gap-1
    w-full
    flex-nowrap
    p-1.5
    rounded-[12px] gradient-box 
  `}
      >
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              type="button"
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex-1
                px-4 py-2.5
                text-sm font-semibold
                flex items-center justify-center gap-2
                rounded-lg
                transition-all duration-200
                capitalize
                whitespace-nowrap
                text-white
                ${
                  variant === 'pill'
                    ? isActive
                      ? `bg-tab-gredient shadow-md shadow-orange-900/40 ${ActivetabClassName}`
                      : `bg-transparent text-[#888] hover:text-white hover:bg-white/5 ${InActivetabClassName}`
                    : isActive
                      ? `border-b-2 border-[#ff6a2f] font-semibold text-[#ff6a2f]`
                      : `text-[#888] hover:text-[#ff6a2f]`
                }
              `}
            >
              {/* SVG / img icon */}
              {showIcons && tab.img && (
                <div className="p-2 bg-primary-tabg rounded-full">
                  <Images
                    src={tab.img}
                    alt=""
                    className={`w-4 h-4 ${isActive ? 'brightness-0 invert' : 'opacity-50'}`}
                  />
                </div>
              )}

              {/* React node icon */}
              {showIcons && tab.icon && (
                <span className="inline-flex items-center">{tab.icon}</span>
              )}

              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
